package kz.dentalcrm.app.data.network.response_model

import kotlinx.serialization.Serializable

@Serializable
data class LoginResponse(
    val expires_in: Int,
    val role: Int,
    val token: String
)